import { Card, CardContent } from '@commander/ui';

export function ErrorCard({ message }: { message: string }) {
  return (
    <Card role="alert" className="border-destructive/50 bg-destructive/5">
      <CardContent className="p-3">
        <p className="text-xs font-medium text-destructive">Something went wrong</p>
        <p className="mt-1 text-xs text-muted-foreground">{message}</p>
      </CardContent>
    </Card>
  );
}
